export default __webpack_public_path__ + "static/media/step-end.eb707901.png";